import React from "react";
import './EntryDescButton.css';
import Tooltip from '@mui/material/Tooltip';
import Fab, {FabProps} from '@mui/material/Fab';
import {EntryDesc} from 'generated/JavaTOmodifications';
import {SisName} from 'util/SisName';
import {getEntryDescColorObj} from 'module/edesc/EntryDescUtil'
import {getDeviceForApp} from 'util/AppName'
import {css} from '@emotion/react'
import FontAwesome from 'react-fontawesome'
import {dropFAPrefix} from 'module/maintenance/util/dropFAPrefix'

const cssSmallLabel = css`
	position: absolute;
	padding-top: 4px;
	font-size: 7px;
`

interface Props extends Omit<FabProps, 'children'> {
	entryDesc?: EntryDesc
	selected?: boolean;
}

export const EntryDescButton = React.memo(({entryDesc, selected, ...props}: Props) => {
	const {hourCategory, sisName, longLabel, primaryShortLabel, secondaryShortLabel, icon} = entryDesc || {};
	const {bgColor, textColor} = entryDesc && getEntryDescColorObj(entryDesc, getDeviceForApp()) || {};
	const buttonStyle = {
		background: bgColor,
		color: textColor,
		borderRadius: 30,
		zIndex: 0,
		...(selected ? {boxShadow: '0em 0 1.1em #05165a'} : {}),
	};
	if (sisName === SisName.Persurl) {
		buttonStyle.borderRadius = 0;
	} else if (hourCategory?.trim()) {
		buttonStyle.borderRadius = 10
	}
	let _icon = dropFAPrefix(icon);
	return (
		<Tooltip disableInteractive title={longLabel || 'Typ nicht gefunden'} placement={"top"}>
			<span>
			<Fab className={'EntryDescButton'}
			     style={buttonStyle}
			     {...props}>
				{
					_icon && <FontAwesome name={_icon}/>
					|| <>
						{primaryShortLabel || '?'}
						{secondaryShortLabel && <span css={cssSmallLabel}><br/>{secondaryShortLabel}</span>}
					</>}
			</Fab>
			</span>
		</Tooltip>
	);
});